/**
 * Foundation.Session.Manager's interface to Foundation.Login.
 * @constructor
 * @implements {Foundation.Session.Manager.Delegate}
 */
Foundation.Login.SessionManagerDelegate = function () {};

/**
 * @return {string}
 */
Foundation.Login.SessionManagerDelegate.prototype.sessionManagerID = function () {
    return "foundation";
};

/**
 * @return {Foundation.Promise!}
 */
Foundation.Login.SessionManagerDelegate.prototype.logOut = function () {
    // Cancel the persistent timer that would attempt to log us out.
    var timer = Foundation.Timer.Persistent.timerForId("login-expiration");
    if (timer) timer.cancel();

    return new Foundation.API("DELETE", "Login/CookieV2");
};

Foundation.Login.SessionManagerDelegate.prototype.revalidateLogin = function () {
    // Don't need to do anything here.
};

Foundation.Login.SessionManagerDelegate.prototype.observeExternalSessionEvents = function () {
    // We're not set up to do anything like this with the native 
    // Foundation login yet.
};

Foundation.Login.SessionManagerDelegate.prototype.unobserveExternalSessionEvents = function () {
    // We're not set up to do anything like this with the native
    // Foundation login yet.
};

// ---------------------------------------------------------------------

Foundation.Session.Manager.sharedInstance().registerDelegate(new Foundation.Login.SessionManagerDelegate());
